export const maskSMS = (sms) => `(XXX) XXX-${sms.slice(sms.length - 4)}`;
/**
 * Emails returned from the backend have two pre-masked formats as
 * of 7/25/22 they are:
 *
 *   1. jef******@ally.com
 *   2. je......n@ally.com
 *
 * #2 is modified below to the expected format, but #1 is displayed
 * as returned from the server.
 */
export const maskEmail = (email) => {
    // if masked on the server, return as is
    if (email.includes('***')) {
        return email;
    }
    const [username, domain] = email.split('@');
    if (username && domain) {
        // If the email is a@ally.com we don't want to mask it
        if (username.length === 1) {
            return email;
        }
        const firstChar = username.charAt(0);
        const lastChar = username.charAt(username.length - 1);
        return `${firstChar}...${lastChar}@${domain}`;
    }
    return email;
};
/**
 * this accommodates two types:
 * DeliveryType (SMS | EMAIL | '') and
 * ReadableDeliveryMethod (text message | email | unknown)
 *
 * if we get unknown or empty string, simply return the raw Transmit value
 */
export const maskBy = {
    'text message': maskSMS,
    sms: maskSMS,
    SMS: maskSMS,
    voice: maskSMS,
    VOICE: maskSMS,
    email: maskEmail,
    EMAIL: maskEmail,
    unknown: (value) => value,
    '': (value) => value,
};
//# sourceMappingURL=maskOTP.js.map